import Embed from './text-editor-embed';

class Hashtag extends Embed {
  static className = 'h-hashtag';
}

Hashtag.blotName = 'hashtag';

export default Hashtag;
